import { PropsWithChildren } from "react"
import { useLastUpdateDate } from "~/ui-rtk/hooks/cube"
import useDate from "~/ui-rtk/hooks/date"
import P from "~/ui-rtk/components/ui/typography/P"
import { Loader } from "~/ui-rtk/components/ui/common/Loader"
import { cn } from "~/ui-rtk/utils/tailwind-utils"

const dayjs = useDate()

type TLastUpdateChipProps = {
  lastDate?: string
  usedInTooltip?: boolean
  isLoading?: boolean
}

export function LastUpdatedChip(
  props: PropsWithChildren<TLastUpdateChipProps>,
) {
  const { lastDate, isLoading, children, usedInTooltip } = props

  const className = usedInTooltip
    ? "bg-transparent border-none p-0"
    : "bg-basic-dark-blue border border-basic-blue"
  return isLoading || lastDate ? (
    <div
      className={cn(
        "gap-2 justify-center px-2 py-1.5 rounded-md flex items-center text-sm line-height-3 font-semibold leading-5",
        className,
      )}
    >
      {isLoading ? (
        <Loader size={20} />
      ) : (
        <P className="font-bold text-sm">
          {children} {dayjs(lastDate).format("MMM D, YYYY")}
        </P>
      )}
    </div>
  ) : null
}

type TLastUpdateChipStandaloneProps = {
  dateMetric?: string
  filterMetrics?: string[]
}

export default function LastUpdatedChipStandalone(
  props: PropsWithChildren<TLastUpdateChipStandaloneProps>,
) {
  const { dateMetric, filterMetrics, children } = props
  const lastUpdate = useLastUpdateDate(
    dateMetric ? { dateMetric, filterMetrics } : undefined,
  )

  return <LastUpdatedChip {...lastUpdate}>{children}</LastUpdatedChip>
}
